var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !!_vm.old && !_vm.forceHide ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.emit,
      "mouseenter": function ($event) {
        _vm.valueShown = true;
      },
      "mouseleave": function ($event) {
        _vm.valueShown = false;
      }
    }
  }, [!_vm.isNew ? _c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "label": '',
      "name": "clock"
    }
  }) : _c('icon', {
    staticClass: "text-teal-600",
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" "), !_vm.isNew ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.valueShown,
      expression: "valueShown"
    }],
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "absolute flex flex-col rounded-xl bg-pink-600 text-white bottom-6 shadow-lg w-max z-20 px-4 py-3",
    class: {
      'right-0': _vm.right
    }
  }, [_c('div', {
    staticClass: "text-base"
  }, [_vm._v("Aperçu des changements")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm",
    domProps: {
      "innerHTML": _vm._s(_vm.displayValue)
    }
  })])]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.valueShown,
      expression: "valueShown"
    }],
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "absolute rounded-md bg-teal-600 text-white px-4 py-3 bottom-6 shadow-lg w-max z-20",
    class: {
      'right-0': _vm.right
    }
  }, [_c('div', {
    staticClass: "text-sm w-full"
  }, [_vm._v("Importer depuis le Neopass")])])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }